export default __webpack_public_path__ + "static/media/037-pipe.8d031d5a.png";